import React, { useState, useRef, useEffect } from "react";
import { IoMdCloudUpload } from "react-icons/io";
import { AiOutlineDelete } from "react-icons/ai";
import "../../index.css";
import { useQuery, gql, useMutation } from "@apollo/client";
import axios from "axios";
import BackButton from "../CommonComponents/BackButton";
import CustomSwitch from "../CommonComponents/CustomSwitch";
import EmployeeChangeHistoryModal from "./EmployeeChangeHistoryModal";
import BeauticianCustomerProfile from "./BeauticianCustomerProfile";

const UPDATE_EMPLOYEE = gql`
  mutation updateAdminEmployee($data: UpdateEmployeeInput!) {
    updateAdminEmployee(data: $data) {
      status
      message
    }
  }
`;

const EditEmployeeForm = ({ setEditForm, editData }) => {
  console.log(editData);
  console.log("edit data");

  const [fullName, setName] = useState(editData.fullName);
  const [contactNumber, setMobileNumber] = useState(editData.contactNumber);
  const [email, setEmail] = useState(editData.email || "");
  // const [inventoryList, setInventoryList] = useState(editData.employeechild);
  // const [employeeInventoryList, setEmployeeInventoryList] = useState(
  //   editData.employeechild
  // );
  const [updateAdminEmployee, { addLoading, addError }] =
    useMutation(UPDATE_EMPLOYEE);
  const [inventoryList, setInventoryList] = useState([]);
  // const [govtIdImage, setGovtIdImage] = useState("");
  const [govtIdImage, setGovtIdImage] = useState(editData.governmentId);
  const [vehicleIdImage, setVehicleIdImage] = useState(editData.vehicleId);
  const [LicenseImage, setLicenseImage] = useState(editData.license);
  const [assignedGender, setAssignedGender] = useState(editData.gender);
  const govtId = useRef(null);
  const vehicleId = useRef(null);
  const license = useRef(null);
  const [baseLat, setBaseLat] = useState(editData.baseLat);
  const [baseLong, setBaseLong] = useState(editData.baseLong);
  const [address, setAddress] = useState(editData.address);
  const [radius, setRadius] = useState(editData.radius);
  // Real values come from GET_EMPLOYEES; the fallbacks only apply to rows
  // that genuinely have nothing set (0 is a real value, hence ??)
  const [salaryType, setSalaryType] = useState(editData.salaryType ?? "MONTHLY");
  const [commissionPercentage, setCommissionPercentage] = useState(editData.commissionPercentage ?? 10);
  const [perDaySalary, setPerDaySalary] = useState(editData.perDaySalary ?? 0);
  const [monthlySalary, setMonthlySalary] = useState(editData.monthlySalary ?? 0);
  // Probation and salary proration count from here
  const [joiningDate, setJoiningDate] = useState(editData.joiningDate || "");
  // Last working day: salary stops after it; payroll still covers that month
  const [leavingDate, setLeavingDate] = useState(editData.leavingDate || "");
  // Own last day of probation; empty = PROBATION_PERIOD_DAYS from joining
  const [probationEnds, setProbationEnds] = useState(editData.probationEnds || "");
  const [showHistory, setShowHistory] = useState(false);
  const [isDummy, setIsDummy] = useState(editData.isDummy || false);
  const [notifyAdmin, setNotifyAdmin] = useState(editData.notifyAdmin || false);

  const [dataList, setDataList] = useState([]);
  const [isFetched, setIsFetched] = useState(true);

  const handleAdd = (e) => {
    console.log("new list");
    e.preventDefault();
    let finalDataObj = {};
    finalDataObj.id = editData.id;
    // finalDataObj.governmentId = govtIdImage;
    // finalDataObj.vehicleId = vehicleIdImage;
    // finalDataObj.license = LicenseImage;
    finalDataObj.address = address;
    finalDataObj.radius = radius;
    finalDataObj.salaryType = salaryType;
    finalDataObj.commissionPercentage = Number(commissionPercentage);
    finalDataObj.perDaySalary = Number(perDaySalary);
    finalDataObj.monthlySalary = Number(monthlySalary);
    finalDataObj.joiningDate = joiningDate;
    finalDataObj.leavingDate = leavingDate;
    finalDataObj.probationEnds = probationEnds;
    finalDataObj.fullName = fullName;
    finalDataObj.email = email;
    finalDataObj.isDummy = isDummy;
    finalDataObj.notifyAdmin = notifyAdmin;
    console.log(finalDataObj);
    // setEditForm(false);
    updateAdminEmployee({
      variables: {
        data: finalDataObj,
      },
    })
      .then((res) => {
        console.log("res is");
        console.log(res);
        if (res.data.updateAdminEmployee.status === "SUCCESS") {
          window.location.reload();
        } else {
          alert(res.data.updateAdminEmployee.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleInventoryChange = (index, event) => {
    const { name, value } = event.target;
    const updatedList = [...inventoryList];
    updatedList[index][name] = value;
    setInventoryList(updatedList);
  };

  const handleInventoryPriceChange = (index, event) => {
    const { name, value } = event.target;
    const updatedList = [...inventoryList];
    updatedList[index][name] = parseInt(value);
    setInventoryList(updatedList);
  };

  const handleRemoveRow = (index) => {
    const updatedList = [...inventoryList];
    updatedList.splice(index, 1);
    setInventoryList(updatedList);
  };

  const handleAddRow = () => {
    // setInventoryList([...inventoryList, { inventoryId: "", price: "" }]);
    setInventoryList([...inventoryList, { inventoryId: "", price: "" }]);
  };

  const handleGovtIdUpload = async (e) => {
    const file = e.target.files[0];
    // console.log(file.file);
    // setGovtIdImage(file);
    e.preventDefault();
    const url = `https://api.barbera.in/img/upload`;
    try {
      const formData = new FormData();

      formData.append("file", file);

      const { data } = await axios.post(url, formData);
      console.log(data);
      if (data.success === true) {
        setGovtIdImage(data.url);
      }
    } catch (error) {
      console.error(error);
      window.alert(error.message + " Try Again");
      // history.push("/dashboard/compliance");
    }
  };

  const handleVehicleIdUpload = async (e) => {
    const file = e.target.files[0];
    // setVehicleIdImage(file);
    e.preventDefault();
    const url = `https://api.barbera.in/img/upload`;
    try {
      const formData = new FormData();

      formData.append("file", file);

      const { data } = await axios.post(url, formData);
      console.log(data);
      if (data.success === true) {
        setVehicleIdImage(data.url);
      }
    } catch (error) {
      console.error(error);
      window.alert(error.message + " Try Again");
      // history.push("/dashboard/compliance");
    }
  };

  const handleLicenseUpload = async (e) => {
    const file = e.target.files[0];
    // setLicenseImage(file);
    e.preventDefault();
    const url = `https://api.barbera.in/img/upload`;
    try {
      const formData = new FormData();

      formData.append("file", file);

      const { data } = await axios.post(url, formData);
      console.log(data);
      if (data.success === true) {
        setLicenseImage(data.url);
      }
    } catch (error) {
      console.error(error);
      window.alert(error.message + " Try Again");
      // history.push("/dashboard/compliance");
    }
  };

  const handleBrowseGovtIdClick = () => {
    govtId.current.click();
  };

  const handleBrowseVehicleIdClick = () => {
    vehicleId.current.click();
  };

  const handleBrowseLicenseClick = () => {
    license.current.click();
  };
  return (
    // <div>lefhwekjh</div>
    <div>
      {isFetched && (
        <div className="flex flex-col space-y-10">
          <BackButton onClick={() => setEditForm(false)}></BackButton>
          <h3 className="font-be-jost-pro font-bold text-2xl text-[#FBB033]">
            Edit Employee Details
          </h3>

          <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Name:
            </span>
            <input
              type="text"
              placeholder="Name*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-2 border-b-[#E0E0E0] outline-none text-white w-full lg:w-5/6"
              value={fullName}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Mobile Number:
            </span>
            <div className="flex items-end w-full px-4">
              <span className="py-1 border-b-2 border-b-[#E0E0E0] text-[#8aa3af]">
                +91
              </span>
              <input
                readOnly
                type="text"
                placeholder="Mobile Number*"
                className="px-2 py-1 bg-[#0c0b0b] border-b-2 border-b-[#E0E0E0] outline-none text-white w-full"
                value={contactNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </div>
          </div>

          <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Email:
            </span>
            <input
              type="email"
              placeholder="Email"
              className="px-2 py-1 bg-[#0c0b0b] border-b-2 border-b-[#E0E0E0] outline-none text-white w-full lg:w-5/6"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              gender:
            </span>
            <input
              // readOnly
              disabled={true}
              type="text"
              placeholder="Name*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-2 border-b-[#E0E0E0] outline-none text-white w-full lg:w-5/6"
              value={assignedGender}
              onChange={(e) => setName(e.target.value)}
            />
            {/* <select
              className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-4/6`}
              value={assignedGender}
              onChange={(e) => setAssignedGender(e.target.value)}
            >
              <option value="" disabled hidden>
                Gender*
              </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select> */}
          </div>
          <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Address:
            </span>
            <input
              type="text"
              placeholder="Address*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-2 border-b-[#E0E0E0] outline-none text-white w-full lg:w-5/6"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              name="Lat"
            />
          </div>
          <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Radius:
            </span>
            <input
              type="number"
              placeholder="Radius*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-full lg:w-1/3"
              value={radius}
              onChange={(e) => setRadius(Number(e.target.value))}
              name="Lat"
            />
          </div>

          <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Joining Date:
            </span>
            <input
              type="date"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-full lg:w-1/3 [color-scheme:dark]"
              value={joiningDate}
              onChange={(e) => setJoiningDate(e.target.value)}
            />
            {!joiningDate && (
              <span className="text-xs text-[#FBB033] lg:ml-3">
                Not set - probation and pay count from when the record was created
              </span>
            )}
          </div>

          <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Probation Ends:
            </span>
            <input
              type="date"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-full lg:w-1/3 [color-scheme:dark]"
              value={probationEnds}
              onChange={(e) => setProbationEnds(e.target.value)}
            />
            <span className="text-xs text-gray-400 lg:ml-3">
              Last day of probation (no paid leave till then). Empty = the global probation days
              from joining.
            </span>
          </div>

          <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Leaving Date:
            </span>
            <input
              type="date"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-full lg:w-1/3 [color-scheme:dark]"
              value={leavingDate}
              onChange={(e) => setLeavingDate(e.target.value)}
            />
            <span className="text-xs text-gray-400 lg:ml-3">
              Last working day. Salary is paid up to this day. Leave empty if still working.
            </span>
          </div>

          <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Salary Type:
            </span>
            <select
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-full lg:w-5/6"
              value={salaryType}
              onChange={(e) => setSalaryType(e.target.value)}
            >
              <option value="MONTHLY">Monthly</option>
              <option value="MONTHLY_PLUS_COMMISSION">Monthly + Commission</option>
              <option value="PER_DAY">Per Day</option>
              <option value="PER_DAY_PLUS_COMMISSION">Per Day + Commission</option>
            </select>
          </div>

          {(salaryType === "MONTHLY" || salaryType === "MONTHLY_PLUS_COMMISSION") && (
            <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
              <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
                Monthly Salary:
              </span>
              <input
                type="number"
                placeholder="Monthly Salary"
                className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-full lg:w-5/6"
                value={monthlySalary}
                onChange={(e) => setMonthlySalary(Number(e.target.value))}
              />
            </div>
          )}

          {(salaryType === "PER_DAY" || salaryType === "PER_DAY_PLUS_COMMISSION") && (
            <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
              <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
                Per Day Salary:
              </span>
              <input
                type="number"
                placeholder="Per Day Salary"
                className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-full lg:w-5/6"
                value={perDaySalary}
                onChange={(e) => setPerDaySalary(Number(e.target.value))}
              />
            </div>
          )}

          {(salaryType.includes("COMMISSION")) && (
            <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
              <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
                Commission %:
              </span>
              <input
                type="number"
                placeholder="Commission Percentage"
                className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-full lg:w-5/6"
                value={commissionPercentage}
                onChange={(e) => setCommissionPercentage(Number(e.target.value))}
              />
            </div>
          )}

          <CustomSwitch
            id="isDummy"
            label="Dummy Employee"
            checked={isDummy}
            onChange={(checked) => setIsDummy(checked)}
          />

          <CustomSwitch
            id="notifyAdmin"
            label="Notify Admin on Booking"
            checked={notifyAdmin}
            onChange={(checked) => setNotifyAdmin(checked)}
          />

          <BeauticianCustomerProfile
            employeeId={editData.id}
            fullName={editData.fullName}
          />
          <div className="flex py-16 w-full justify-center items-center gap-4">
            <button
              className="px-5 py-2 bg-[#FBB034] font-poppins text-sm font-bold rounded-md"
              onClick={handleAdd}
            >
              Update Employee
            </button>
            <button
              type="button"
              className="px-5 py-2 border border-[#FBB034] text-[#FBB034] font-poppins text-sm font-bold rounded-md"
              onClick={() => setShowHistory(true)}
            >
              Employee history
            </button>
          </div>
          {showHistory && (
            <EmployeeChangeHistoryModal
              employeeId={editData.id}
              name={editData.fullName}
              onClose={() => setShowHistory(false)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default EditEmployeeForm;

{
  /* <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Inventory:
            </span>
            <div className="flex flex-col space-y-2 lg:space-y-8">
              {inventoryList.map((inventory, index) => {
                return (
                  <div className="flex space-x-2 lg:space-x-8" key={index}>
                    <select
                      className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${
                        inventory.inventory === ""
                          ? " text-[#9A9A9A]"
                          : "text-white"
                      } w-1/2 lg:w-[25%]`}
                      value={inventory.inventoryId}
                      onChange={(e) => handleInventoryChange(index, e)}
                      name="inventoryId"
                    >
                      <option value="">select Inventory</option>
                      
                      {dataList.map((item, i) => (
                        <option value={item.id} key={i}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    <div className="flex items-center">
                      <span
                        className="text-[#FBB033] font-be-jost-pro text-base font-normal cursor-pointer"
                        onClick={handleAddRow}
                      >
                        {`Add Inventory +  `}
                      </span>
                      {inventoryList.length !== 1 && (
                        <AiOutlineDelete
                          className="text-[#FBB033] text-2xl cursor-pointer"
                          onClick={() => handleRemoveRow(index)}
                        />
                      )}
                    </div>
                    <input
                      type="text"
                      placeholder="Amount*"
                      className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-full lg:w-1/3"
                      value={inventory.price}
                      onChange={(event) =>
                        handleInventoryPriceChange(index, event)
                      }
                      name="price"
                    />
                  </div>
                );
              })}
            </div>
          </div> */
}

{
  /* <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Government Id:
            </span>
            <div className="flex items-center w-full lg:w-1/2">
              <input
                id="govt-id"
                type="file"
                ref={govtId}
                className="hidden"
                onChange={handleGovtIdUpload}
              />
              <input
                type="text"
                placeholder="Government Id*"
                disabled={true}
                className="w-1/2 px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              />
              {editData.governmentId && (
                <a
                  className="ml-3 mr-2 font-be-jost-pro text-[#FBB033] font-normal text-base cursor-pointer"
                  target="_blank" rel="noreferrer"
                  href={`https://api.barbera.in${editData.governmentId}`}
                >
                  View
                </a>
              )}
              <IoMdCloudUpload
                className="text-[#FBB033] text-3xl"
                onClick={handleBrowseGovtIdClick}
              />
            </div>
          </div> */
}

{
  /* <div className="flex space-x-2 lg:space-x-8" >
<span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
        Latitude:
        </span>
        <input
            type="text"
            placeholder="Lat*"
            className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-full lg:w-1/3"
            value={baseLat}
            onChange={(e) => setBaseLat(e.target.value)}
            name="Lat"
          />
         <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
        Longitude:
        </span>
         <input
            type="text"
            placeholder="Long*"
            className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-full lg:w-1/3"
            value={baseLong}
            onChange={(e) => setBaseLong(e.target.value)}
            name="Lat"
          />
        </div> */
}
{
  /* <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              License:
            </span>
            <div className="flex items-center w-full lg:w-1/2">
              <input
                id="govt-id"
                type="file"
                ref={license}
                className="hidden"
                onChange={handleLicenseUpload}
              />
              <input
                type="text"
                placeholder="License*"
                disabled={true}
                className="w-1/2 px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              />
              {editData.license && (
                <a
                  className="ml-3 mr-2 font-be-jost-pro text-[#FBB033] font-normal text-base cursor-pointer"
                  target="_blank" rel="noreferrer"
                  href={`https://api.barbera.in${editData.license}`}
                >
                  View
                </a>
              )}
              <IoMdCloudUpload
                className="text-[#FBB033] text-3xl"
                onClick={handleBrowseLicenseClick}
              />
            </div>
          </div> */
}
{
  /* <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center lg:items-end w-full lg:w-5/6">
            <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
              Vehicle Id:
            </span>
            <div className="flex items-center w-full lg:w-1/2">
              <input
                id="govt-id"
                type="file"
                ref={vehicleId}
                className="hidden"
                onChange={handleVehicleIdUpload}
              />
              <input
                type="text"
                placeholder="Vehicle Id*"
                disabled={true}
                className="w-1/2 px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              />
              {editData.vehicleId && (
                <a
                  className="ml-3 mr-2 font-be-jost-pro text-[#FBB033] font-normal text-base cursor-pointer"
                  target="_blank" rel="noreferrer"
                  href={`https://api.barbera.in${editData.vehicleId}`}
                >
                  View
                </a>
              )}
              <IoMdCloudUpload
                className="text-[#FBB033] text-3xl"
                onClick={handleBrowseVehicleIdClick}
              />
            </div>
          </div> */
}
